import * as React from "react";
import { fileValue } from "../types";

export const SignDocumentGridTemplate = ({cell}) => {
    return (
        <>
            {cell.map((file: fileValue) => {
                const nameIcon = (file?.name || "")?.split(".")?.pop()?.toLowerCase() || "unknown";

                return (
                    <div>
                        <span>
                            <div className="form-control form-control--file" style={{ border: "none", boxShadow: "none" }}>
                                <label className="file-load">
                                    <a download href={file?.url} target="__blank">
                                        <span className="row valign" style={{ height: "100%" }}>
                                            <span className={`fileicon fileicon-${nameIcon}`} />
                                            <span className="control-label control-label--file" title={file?.name} style={{ whiteSpace: "normal" }}>
                                                {file?.name}
                                            </span>
                                        </span>
                                    </a>
                                </label>
                            </div>
                        </span>
                    </div>
                )
            })}
        </>
    )
}